import { AuditInstanceApi } from "~/api/AuditInstance";

export function useAuditInstanceApi(): AuditInstanceApi {
  const auditInstanceApi = new AuditInstanceApi(useHttpClient());
    
  return auditInstanceApi;
}
